import AppSettings from "@/AppSettings";
import { isRestricted } from "@/restricted";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppBar, Button, colors, styled, useTheme } from "@mui/material";
import { FC, ReactNode, memo } from "react";
import { faChevronRight } from '@fortawesome/duotone-light-svg-icons';
import { Link } from 'react-router-dom';
import { inherits } from "util";

export interface IBreadcrumb {
    label: ReactNode;
    link?: string;
    icon: IconProp;
}

interface IBreadcrumbsProps {
    breadcrumbs: IBreadcrumb[];
}


const BreadcrumbBar = styled(AppBar)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? 
        '#252525' :
        AppSettings.palette.breadcrumbBgLight,
    boxShadow: 'none',
    margin: theme.spacing(-3, -3, 3, -3), 
    width: 'auto',
    minHeight: 50,
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
        display: 'none'
    }
}));

const BreadcrumbButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    color: theme.palette.text.secondary,
    borderRadius: 0,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    '&.Mui-disabled': {
        color: theme.palette.text.secondary,
    }
}));


const Breadcrumbs: FC<IBreadcrumbsProps> = ({
    breadcrumbs
}) => {
    const theme = useTheme();

    return (
        <BreadcrumbBar position="static" >
            {
                breadcrumbs?.map((b, i) => {
                    return (
                        <span key={i} style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <BreadcrumbButton
                                //@ts-ignore-next-line
                                component={Link}
                                to={b.link ?? ''}
                                disabled={!b.link || isRestricted}
                                startIcon={<FontAwesomeIcon icon={b.icon} fixedWidth />}
                            >
                                {b.label}
                            </BreadcrumbButton>
                            {i < (breadcrumbs?.length ?? 0) - 1 && (
                                <FontAwesomeIcon
                                    icon={faChevronRight}
                                    fixedWidth
                                    style={{ color: theme.palette.text.secondary}}
                                />
                            )}
                        </span>
                    )
                })
            }
        </BreadcrumbBar>
    )
}

export default memo(Breadcrumbs);